<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'联系客服' | dealLanguage('Contact Us')}}</page-header>
    <div class="contact-wrapper">
      <div class="top-tip" v-if="language == 'zh'"><span>2026CSGCT展会</span>信息一键触达！如需任何咨询或了解更多详情，请扫描下方二维码添加专属客服。</div>
      <div class="top-tip" v-if="language == 'en'"><span>2026CSGCT exhibition</span> information can be easily accessed with just one click! If you need any consultation or more details, please scan the QR code below to add a dedicated customer service representative.</div>
      <div class="qrlist">
        <div class="qritem">
          <div class="title">参展&参会咨询</div>
          <img :src="static_img_url + 'pic/contactUs/li.jpg'" class="qr-img" />
          <p class="p1">李女士<br>18600921680</p>
        </div>
        <div class="qritem">
          <img :src="static_img_url + 'pic/contactUs/ren.jpg'" class="qr-img" />
          <p class="p1">任女士<br>15111945514</p>
        </div>
        <div class="qritem">
          <img :src="static_img_url + 'pic/contactUs/yang.jpg'" class="qr-img" />
          <p class="p1">杨先生<br>15360825131</p>
        </div>
        <div class="qritem">
          <div class="title">媒体及商务合作</div>
          <img :src="static_img_url + 'pic/contactUs/chen.jpg'" class="qr-img" />
          <p class="p1">陈女士<br>18800157211</p>
        </div>
        <div class="qritem">
          <div class="title">参会报名</div>
          <img :src="static_img_url + 'pic/contactUs/huang.jpg'" class="qr-img" />
          <p class="p1">黄女士<br>13801260803</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('联系客服', 'Contact Us'),
    }
  },
  components: {
    PageHeader,
  },
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      language: (state) => state.language,
      static_img_url: (state) => state.static_img_url,
    }),
  },
  methods: {},
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.contact-wrapper
  margin 20px auto 0
  width 1000px
  .top-tip
    font-size 16px
    color #3D3D3D
    line-height 22px
    text-align center
    span
      color #C8161D
  .qrlist
    margin 60px auto
    display flex
    justify-content space-between
    .qritem
      position relative
      padding 40px 0
      .title
        position absolute
        top 0
        left 0
        line-height 20px
        padding-left 10px
        border-left 4px solid #C8161D
        font-weight 600
        font-size 18px
        color #3D3D3D
        white-space nowrap
      .qr-img
        width 120px
        height 120px
        display block
        margin-bottom 10px
      .p1
        font-size 14px
        color #333333
        line-height 20px
        text-align center
</style>